import { ProcessModel, MappingModel, CommCodeModel, QueueModel } from '@common/MappingProgramProcess/model';
import api from './api';
import * as types from './mutation-types';

export default {
	fetchProcesses_: ({ state, commit }, payload) => {
		return api
			.fetchProcesses(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { pagingInfo, resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: pagingInfo
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'mappings',
						value: resultList.map(mapping => new MappingModel(mapping))
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPlants_: ({ state, commit }) => {
		return api
			.fetchPlants()
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					const plants = body.map(commCode => new CommCodeModel(commCode));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							plants
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchServiceKinds_: ({ state, commit }, payload) => {
		return api
			.fetchServiceKinds(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					const serviceKinds = body
						.map(commCode => new CommCodeModel(commCode))
						.map(r => {
							r.label = r.label.trim();
							r.value = r.value.trim();
							return r;
						});
					// const transformed = _.each(serviceKinds, o => _.each(o, (v, k) => (o[k] = v.trim())));
					// console.log('serviceKinds', transformed);
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							serviceKinds
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPgmIds_: ({ state, commit }, payload) => {
		return api
			.fetchPgmIds(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					const pgmIds = body;

					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							pgmIds
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchProcIdsByPgmId_: ({ state, commit }, payload) => {
		return api
			.fetchProcIdsByPgmId(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				if (code === 0) {
					const procIds = body;
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							procIds
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchProcIds_: ({ state, commit }, payload) => {
		return api
			.fetchProcIds(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { resultList } = body;
				if (code === 0) {
					const procIds = resultList.map(process => new ProcessModel(process));
					commit(types.DEFAULT_ASSIGN, {
						key: 'selectOptions',
						value: {
							...state.selectOptions,
							procIds
						}
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	createMapping_: ({ state, commit }, payload) => {
		return api
			.createMapping(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	updateMapping_: ({ state, commit }, payload) => {
		return api
			.updateMapping(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	deleteMapping_: ({ state, commit }, { mapping }) => {
		return api
			.deleteMapping(mapping)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchQueues_: ({ state, commit }, payload) => {
		return api
			.fetchQueues(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'queues',
						value: resultList.map(queue => new QueueModel(queue))
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	fetchPgmQueueMaps_: ({ state, commit }, payload) => {
		return api
			.fetchPgmQueueMaps(payload)
			.then(data => {
				const { header, body } = data;
				const { code } = header;
				const { resultList } = body;
				if (code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pgmQueueMaps',
						value: resultList
					});
				} else if (code === 3) {
					// TODO
				}
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	updatePgmQueueMaps_: ({ state, commit }, payload) => {
		return api
			.updatePgmQueueMaps(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	},

	deletePgmQueueMaps_: ({ state, commit }, payload) => {
		return api
			.deletePgmQueueMaps(payload)
			.then(data => {
				const { header } = data;
				return header;
			})
			.catch(error => {
				throw error;
			});
	}
};
